import exclamationIcon from 'assets/icons/icon-exclamation.svg';
import { INVOICED_STATUS } from 'common/constants';
import { useStoreSelector } from 'v3/data/store';
import {
  setCancelationErrorModalOpen,
  setCancelationModalOpen,
  setCurrentCancellationState,
  setRefundConflictModalOpen,
} from 'v3/data/store/cancellationNavigation/actions';
import { CancellationNavigationEnum } from 'v3/data/store/cancellationNavigation/enum';
import { Content } from 'v3/pages/Contracting/Details/styles';
import { AlignButtons, AlignIcon, Icon, TitleSection } from 'v3/pages/OnlineContracting/Cancellation/styles';
import { useFetchContractingDetails } from 'v3/pages/OnlineContracting/Details/get-contracting-details-hook';
import * as onlineApi from 'v3/services/online/api';
import { CancellationActionEnum } from 'v3/services/online/interfaces/types';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { theme } from 'v3/styles/global-styles';

export const RequestRefundStep = () => {
  const { orderId } = useStoreSelector((store) => store.onlineContracting.paymentDetails);
  const { contractingKey } = useStoreSelector((store) => store.onlineContracting);
  const { fetchContractingDetails } = useFetchContractingDetails();
  const { storeUserId } = useStoreSelector((store) => store.store.storeLogged);

  const handleCloseModal = () => {
    setCancelationModalOpen(false);
  };

  const handleConfirmRefund = async () => {
    try {
      if (!orderId) {
        await fetchContractingDetails(contractingKey);
      }
      const vtexResponse = await onlineApi.getVtexOrder(orderId);
      if (vtexResponse.data.status === INVOICED_STATUS) {
        setCancelationModalOpen(false);
        setRefundConflictModalOpen(true);
      } else {
        await onlineApi.cancelVtexOrder(orderId, {
          reason: 'Requisição de reembolso feita pelo Backoffice',
          storeUserId: storeUserId,
          action: CancellationActionEnum.REFUND,
        });
        setCurrentCancellationState(CancellationNavigationEnum.PROCESSING_CANCELLATION);
      }
    } catch (error) {
      console.error('Error confirming refund:', error);
      setCancelationErrorModalOpen(true);
    }
  };

  return (
    <Content>
      <AlignIcon>
        <Icon src={exclamationIcon} alt="Alert" />
      </AlignIcon>
      <TitleSection>
        <HeadlineSmall>Tem certeza que quer fazer o estorno?</HeadlineSmall>
        <SubtitleLarge color={theme.palette.info.main}>
          Essa ação é irreversível e o valor será devolvido ao cliente
        </SubtitleLarge>
      </TitleSection>
      <AlignButtons>
        <TextButton text="Voltar" $outline size="small" fullWidth handleClick={handleCloseModal} />
        <FlexButton text="Sim, tenho certeza" size="small" fullWidth handleClick={handleConfirmRefund} />
      </AlignButtons>
    </Content>
  );
};
